import { Alert, Col, Divider, Row, Spin, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useMemo } from "react";
import { CarpoolStore } from "./store";
import { CarpoolColumn } from "./components/CarpoolColumn";

export const CarpoolPage = observer(() => {
  const store = useMemo(() => new CarpoolStore(), []);

  useEffect(() => {
    store.loadAll();
  }, [store]);

  if (store.loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (store.error) {
    return <Alert type="error" message="Fehler beim Laden" description={store.error} style={{ margin: 24 }} />;
  }

  return (
    <div style={{ padding: "16px 24px" }}>
      <Typography.Title level={3} style={{ marginBottom: 24 }}>
        Mitfahrgelegenheiten
      </Typography.Title>
      <Row gutter={32}>
        <Col xs={24} md={12}>
          <CarpoolColumn
            store={store}
            direction="to"
            role="driver"
            title="Fahrer – Hinfahrt zum Festival"
            carpools={store.toDriverOffers}
          />
        </Col>
        <Col xs={24} md={12}>
          <CarpoolColumn
            store={store}
            direction="from"
            role="driver"
            title="Fahrer – Rückfahrt vom Festival"
            carpools={store.fromDriverOffers}
          />
        </Col>
      </Row>
      <Divider />
      <Row gutter={32} style={{ marginTop: 32 }}>
        <Col xs={24} md={12}>
          <CarpoolColumn
            store={store}
            direction="to"
            role="rider"
            title="Mitfahrgelegenheit gesucht – Hinfahrt zum Festival"
            carpools={store.toRideRequests}
          />
        </Col>
        <Col xs={24} md={12}>
          <CarpoolColumn
            store={store}
            direction="from"
            role="rider"
            title="Mitfahrgelegenheit gesucht – Rückfahrt vom Festival"
            carpools={store.fromRideRequests}
          />
        </Col>
      </Row>
      <Divider />
      <Typography.Title level={3} style={{ marginBottom: 24 }}>
        Und für alle, die mit dem Zug kommen und nicht allein fahren wollen 😉
      </Typography.Title>
      <Row gutter={32} style={{ marginTop: 32 }}>
        <Col xs={24} md={12}>
          <CarpoolColumn
            store={store}
            direction="to"
            role="train"
            title="Zugverbindung – Hinfahrt zum Festival"
            carpools={store.toTrainConnections}
          />
        </Col>
        <Col xs={24} md={12}>
          <CarpoolColumn
            store={store}
            direction="from"
            role="train"
            title="Zugverbindung – Rückfahrt vom Festival"
            carpools={store.fromTrainConnections}
          />
        </Col>
      </Row>
    </div>
  );
});
